import { render, staticRenderFns } from "./ChapterExam.vue?vue&type=template&id=5cb1cd09&scoped=true&"
import script from "./ChapterExam.vue?vue&type=script&lang=js&"
export * from "./ChapterExam.vue?vue&type=script&lang=js&"
import style0 from "./ChapterExam.vue?vue&type=style&index=0&id=5cb1cd09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb1cd09",
  null
  
)

export default component.exports